var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5C16 6.37827 15.1571 4.34344 13.6569 2.84315C12.1566 1.34285 10.1217 0.5 8 0.5C5.87827 0.5 3.84344 1.34285 2.34315 2.84315C0.842855 4.34344 0 6.37827 0 8.5C0 10.6217 0.842855 12.6566 2.34315 14.1569C3.84344 15.6571 5.87827 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5ZM7.508 7.41C7.52887 7.29472 7.58957 7.19043 7.67949 7.11532C7.76941 7.04022 7.88284 6.99908 8 6.99908C8.11716 6.99908 8.23059 7.04022 8.32051 7.11532C8.41043 7.19043 8.47113 7.29472 8.492 7.41L8.5 7.5V12.002L8.492 12.092C8.47113 12.2073 8.41043 12.3116 8.32051 12.3867C8.23059 12.4618 8.11716 12.5029 8 12.5029C7.88284 12.5029 7.76941 12.4618 7.67949 12.3867C7.58957 12.3116 7.52887 12.2073 7.508 12.092L7.5 12.002V7.5L7.508 7.41ZM7.25 5.25C7.25 5.05109 7.32902 4.86032 7.46967 4.71967C7.61032 4.57902 7.80109 4.5 8 4.5C8.19891 4.5 8.38968 4.57902 8.53033 4.71967C8.67098 4.86032 8.75 5.05109 8.75 5.25C8.75 5.44891 8.67098 5.63968 8.53033 5.78033C8.38968 5.92098 8.19891 6 8 6C7.80109 6 7.61032 5.92098 7.46967 5.78033C7.32902 5.63968 7.25 5.44891 7.25 5.25Z",
    fill: "#4F7BF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFilled);
export default __webpack_public_path__ + "static/media/info-filled.6e5ddd40.svg";
export { ForwardRef as ReactComponent };